import { render, staticRenderFns } from "./talent-recruitment.vue?vue&type=template&id=2e851d5a&scoped=true"
var script = {}
import style0 from "./talent-recruitment.vue?vue&type=style&index=0&id=2e851d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e851d5a",
  null
  
)

export default component.exports